import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DataCoreServices.css"

import Governance from "../../assests/Data-Governance.svg"; 
import Integration from "../../assests/Data-Integration.svg"
import Analytics from "../../assests/dataanalytics.svg" 
import Quality from "../../assests/Data-Quality.svg"
import CustomLLM from "../../assests/Custom-LLM.svg"
import GenerativeAI from "../../assests/Generative-AI.svg"
import AgenticAI from "../../assests/Agentic-AI.svg"; 
const DataCoreServices = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className="pt-5 data-management">
        <h2 className="text-center mb-2  datacore-h2">Performance & Insights at Scale</h2>
        <p className="text-center performance-p-data mb-5">Drive decisions | Track KPIs | Discover trends</p>

        {/* IoT Solutions */}
        <Row className="align-items-center mb-4   card-image-1 card-padding-data">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start">
              <h4 className=" mb-4 datacore-h4">Data Platform Engineering  </h4>
              <ul className="mb-0 datacore-ul">
                <li>
                  Build <span className="bold-span"> scalable, integrated data platforms</span> for centralized storage, processing, and access.   
                </li>
                <li>
                  Ensure <span className="bold-span">real-time data availability</span> across departments for faster insights. 
                </li>
                {/* <li>
                  <span className="bold-span">ETL pipelines</span> (Extract, Transform, Load) for structured & unstructured data. 
                </li>
                <li>
                  Zero-downtime cutovers for business continuity.  
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={Integration} alt="Predictive-Analytics" className="img-fluid-data" />
          </Col>
        </Row>

        {/* Robotics Solutions */}
          <Row className="align-items-center mb-4 flex-md-row-reverse  card-image-2 card-padding-data">
            <Col md={7} xs={12}>
              <div className="p-4  h-100 text-start ai-text-data">
                <h4 className=" mb-4 datacore-h4">Advanced Reporting & BI </h4>
                <ul className="mb-0 datacore-ul">
                  <li>
                    Create<span className="bold-span"> interactive dashboards </span>and advanced BI reports for executive and operational insights
                  </li>
                  <li>
                    Empower organizations with <span className="bold-span">actionable intelligence </span>to make informed business decisions. 
                  </li>
                  {/* <li>
                    Complete visibility with data lineage tracking and audit trails. 
                  </li>
                  <li>
                  Automated compliance reporting to <span className="bold-span">reduce manual work</span>.
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
              <img
                src={Governance}
                alt="Robotics Solutions"
                className="img-fluid-data"
              />
            </Col>
          </Row>

        <Row className="align-items-center mb-4   card-image-3 card-padding-data">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text-data">
              <h4 className=" mb-4 datacore-h4">Seamless Data Migration </h4>
              <ul className="mb-0 datacore-ul">
                <li>
                 Execute secure <span className="bold-span">data migration across systems and cloud platforms</span> with minimal disruption.  
                </li>
                <li>
                 Ensure <span className="bold-span">data integrity, compliance, and audit readiness</span> during every migration project.  
                </li>
                {/* <li>
                  AI-driven enrichment to fill gaps with external verified sources. 
                </li>
                <li>
                  Continuous monitoring to <span  className="bold-span">sustain long-term accuracy</span>.  
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img
              src={Quality}
              alt="Robotics Solutions"
              className="img-fluid-data"
            />
          </Col>
        </Row>


        {/* <Row className="align-items-center mb-4 flex-md-row-reverse  card-image-4 card-padding-data">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text-data">
              <h4 className=" mb-4 datacore-h4">Data Analytics & Readiness </h4>
              <ul className="mb-0 datacore-ul">
                <li>
                  Build data warehouses and data lakes for storage at scale.  
                </li>
                <li>
                  Real-time streaming pipelines for <span className="bold-span">instant visibility</span>. 
                </li>
                <li>
                  API and <span className="bold-span">dashboard integration for BI</span> tools like Power BI, Tableau, and Looker.  
                </li>
                <li>
                  Ready-to-use data pipelines for<span className="bold-span"> AI/ML model training</span>. 
                </li>
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={Analytics}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row> */}
    </div>
    </div>
  );
};

export default DataCoreServices;
